// REACT
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Switch from 'react-switch';
import { Item as MenuItem } from 'rc-menu';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FaQuestion } from 'react-icons/fa';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import { ReactComponent as ClearButton } from '../../../../header/images/clear.svg';

//CUSTOM
import * as helpers from '../../../../helpers/helpers';
import FloatingMenu, {
  FloatingMenuItem,
} from '../../../../helpers/FloatingMenu.jsx';
import Portal from '../../../../helpers/Portal.jsx';
import './TOCHeader.css';
class TOCHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
  }

  searchLayerNaming = (layerNumber) => {
    if (layerNumber.endsWith('1')) return ' sloj';
    else if (
      layerNumber.endsWith(2) ||
      layerNumber.endsWith(3) ||
      layerNumber.endsWith(4)
    )
      return ' sloja';
    else return ' slojeva';
  };

  onSettingsClick = (evt) => {
    var evtClone = Object.assign({}, evt);
    var switchMenuLabel = `Prikaži kao ${
      this.props.tocType === 'LIST' ? 'direktorije' : 'listu'
    }`;
    const menu = (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          title="Layer Settings"
          item={this.props.info}
          onMenuItemClick={(action) => this.onSettingsMenuItemClick(action)}
          styleMode="right"
          width={'200px'}
          yOffset={0}
        >
          {/* <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-switch"
          >
            <FloatingMenuItem
              imageName={'edit-rotate24.png'}
              label={switchMenuLabel}
            />
          </MenuItem> */}
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-save"
          >
            <FloatingMenuItem
              imageName={'save-disk.png'}
              label="Sačuvaj promjene"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-reset"
          >
            <FloatingMenuItem
              imageName={'reset.png'}
              label="Vrati slojeve na zadano"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-visility"
          >
            <FloatingMenuItem
              imageName={'layers-off.png'}
              label="Isključi sve slojeve"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-legend"
          >
            <FloatingMenuItem
              imageName={'legend24.png'}
              label="Prikaži legendu"
            />
          </MenuItem>
          <MenuItem className="fs-layers-slider" key="fs-floating-menu-opacity">
            Prilagodi providnost
            <SliderWithTooltip
              tipFormatter={this.sliderTipFormatter}
              max={1}
              min={0}
              step={0.05}
              defaultValue={this.props.globalOpacity}
              onChange={(evt) => this.props.onGlobalOpacityChange(evt)}
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-sort"
          >
            Sortiraj slojeve
            <Switch
              className="fs-toc-sort-switch"
              onChange={this.props.onSortChange}
              checked={this.props.sortAlpha}
              height={20}
              width={48}
            />
          </MenuItem>
        </FloatingMenu>
      </Portal>
    );

    ReactDOM.render(menu, document.getElementById('portal-root'));
  };

  onSettingsMenuItemClick = (action) => {
    switch (action) {
      case 'fs-floating-menu-visility':
        this.props.onTurnOffLayers();
        break;
      case 'fs-floating-menu-save':
        // this.onSaveClick();
        this.props.onSaveAllLayers();
        break;
      case 'fs-floating-menu-save-all':
        this.props.onSaveAllLayers();
        break;
      case 'fs-floating-menu-reset':
        this.props.onResetToDefault();
        break;
      case 'fs-floating-menu-legend':
        this.props.onOpenLegend();
        break;
      case 'fs-floating-menu-switch':
        this.props.onTOCTypeChange();
        break;

      default:
        break;
    }
    helpers.addAppStat('TOC Settings - ', action);
  };
  onSearchClear = () => {
    this.setState({ searchText: '' }, () => {
      this.props.onSearchChange('');
    });
  };

  onSearchChange = (evt) => {
    const searchText = evt.target.value;
    this.setState({ searchText: searchText }, () => {
      this.props.onSearchChange(searchText);
    });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.searchText === '' && this.state.searchText !== '') {
      this.setState({ searchText: nextProps.searchText });
    }
  }

  render() {
    return (
      <div>
        <div
          className={
            this.props.isLoading
              ? 'fs-toc-main-container-loading'
              : 'fs-toc-main-container-loading fs-hidden'
          }
        >
          <img
            className="fs-toc-loading"
            src={images['loading.gif']}
            alt="loading"
          />
        </div>
        <div
          className={
            this.props.isLoading
              ? 'fs-toc-main-container fs-hidden'
              : 'fs-toc-main-container'
          }
        >
          <div className="fs-toc-search-container">
            <input
              id="fs-toc-search-textbox"
              className={`fs-toc-search-textbox${
                this.props.helpLink ? ' short' : ''
              }`}
              placeholder={
                'Filtriraj (' +
                this.props.layerCount +
                this.searchLayerNaming(this.props.layerCount.toString()) +
                ')'
              }
              type="text"
              onChange={this.onSearchChange}
              onFocus={(evt) => {
                helpers.disableKeyboardEvents(true);
              }}
              onBlur={(evt) => {
                helpers.disableKeyboardEvents(false);
              }}
              value={this.state.searchText}
            />
            <ClearButton
              className={
                this.state.searchText !== ''
                  ? 'fs-toc-search-textbox-clear'
                  : 'fs-hidden'
              }
              onClick={this.onSearchClear}
            />
            {/* 
            <div
              id="fs-toc-header-help"
              className={
                this.props.helpLink ? 'fs-toc-header-help' : 'fs-hidden'
              }
              alt={`View Layers Help`}
              title={`View Layers Help`}
              onClick={() => helpers.showURLWindow(this.props.helpLink, false)}
            >
              <FaQuestion />
            </div> */}
            <div
              data-tip="Layer Settings"
              data-for="fs-toc-settings-tooltip"
              className="fs-toc-settings-image"
              onClick={this.onSettingsClick}
            >
              <ReactTooltip
                id="fs-toc-settings-tooltip"
                className="fs-toc-settings-tooltip"
                multiline={false}
                place="right"
                type="dark"
                effect="solid"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TOCHeader;
// SLIDER
const SliderWithTooltip = createSliderWithTooltip(Slider);
// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('../images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
